import "../_namespaces.js";
import "./sum.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Scoring ??= {};

AssessmentViewer.Scoring.Average = {
  calculate(points) {
    return this.average(points);
  },

  average(points) {
    const sum = AssessmentViewer.Scoring.Sum.calculate(points);
    const count = points.length;
    const score = count ? sum / count : 0;
    return Math.round(score * 10) / 10;
  }, // Round to 1 decimal
};
